import { useState } from "react";
import { CaretUpDown, Check, Plus } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";

export const ProductSelect = ({ products, value, onChange, allowCustom = false, testId, placeholder = "Select product…" }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const trimmed = query.trim();
  const exact = products.some((p) => p.name.toLowerCase() === trimmed.toLowerCase());

  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (!o) setQuery(""); }}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className="mt-1 flex w-full items-center justify-between gap-2 rounded-md border border-slate-300 bg-white px-3 py-2 text-left text-sm outline-none transition-colors duration-150 focus:border-slate-900">
          <span className={`truncate ${value ? "text-slate-900" : "text-slate-400"}`}>{value || placeholder}</span>
          <CaretUpDown size={14} className="shrink-0 text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0" align="start" style={{ width: "var(--radix-popover-trigger-width)", minWidth: 220 }}>
        <Command>
          <CommandInput placeholder="Search products…" value={query} onValueChange={setQuery} data-testid={`${testId}-search`} />
          <CommandList>
            <CommandEmpty data-testid={`${testId}-empty`} className="p-3 text-center text-xs text-slate-500">
              {allowCustom ? "No matching product." : "No matching product. Ask an admin to add it from the Masters page."}
            </CommandEmpty>
            <CommandGroup>
              {products.map((p) => (
                <CommandItem key={p.id} value={p.name} data-testid={`${testId}-option-${p.id}`}
                  onSelect={() => { onChange(p.name); setOpen(false); setQuery(""); }}>
                  <Check size={14} className={value === p.name ? "opacity-100" : "opacity-0"} />
                  {p.name}
                </CommandItem>
              ))}
            </CommandGroup>
            {allowCustom && trimmed && !exact && (
              <CommandGroup forceMount>
                <CommandItem value={`__new__${trimmed}`} forceMount data-testid={`${testId}-add-custom`}
                  onSelect={() => { onChange(trimmed); setOpen(false); setQuery(""); }}>
                  <Plus size={14} className="text-slate-500" />
                  Add "{trimmed}" as new product
                </CommandItem>
              </CommandGroup>
            )}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
